import type React from 'react';
import type { IconProps } from 'types/icon';

const Stethoscope: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M21.7076 10.1902C21.7075 9.15886 20.8705 8.32301 19.8383 8.32301C18.8061 8.32302 17.9696 9.15886 17.9696 10.1902C17.9696 11.2216 18.8061 12.0579 19.8383 12.0579C20.8705 12.0579 21.7076 11.2216 21.7076 10.1902ZM22.7997 10.1902C22.7997 11.8243 21.4737 13.1491 19.8383 13.1491C18.2029 13.1491 16.877 11.8242 16.877 10.1902C16.877 8.55618 18.2029 7.23132 19.8383 7.23131C21.4737 7.23131 22.7997 8.55617 22.7997 10.1902Z"
        fill={color}
      />
      <path
        d="M19.8384 10.7948C20.1726 10.7948 20.4435 10.5242 20.4435 10.1903C20.4435 9.8564 20.1726 9.58574 19.8384 9.58574C19.5043 9.58574 19.2334 9.8564 19.2334 10.1903C19.2334 10.5242 19.5043 10.7948 19.8384 10.7948Z"
        fill={color}
      />
      <path
        d="M7.75265 15.6261C8.75513 15.6261 9.5678 14.8141 9.5678 13.8124C9.5678 12.8108 8.75513 11.9988 7.75265 11.9988C6.75017 11.9988 5.9375 12.8108 5.9375 13.8124C5.9375 14.8141 6.75017 15.6261 7.75265 15.6261Z"
        fill={color}
      />
      <path
        d="M12.5875 2.40008C13.5453 2.40008 14.3636 3.18046 14.302 4.18322L14.3015 4.18522C14.1761 6.1288 13.7531 8.6217 12.7838 10.6479C11.8146 12.6736 10.2279 14.3583 7.75236 14.3583C7.45076 14.3583 7.20605 14.1137 7.20605 13.8124C7.20607 13.5111 7.45077 13.2666 7.75236 13.2666C9.61984 13.2666 10.9126 12.0284 11.7983 10.1771C12.6837 8.3263 13.0911 5.98787 13.2119 4.11468C13.2311 3.78617 12.9621 3.49178 12.5875 3.49178H11.3777C11.0761 3.49178 10.8314 3.24727 10.8314 2.94593C10.8314 2.64458 11.0761 2.40008 11.3777 2.40008H12.5875Z"
        fill={color}
      />
      <path
        d="M4.12777 2.40004C4.4293 2.40012 4.67357 2.64459 4.67357 2.94589C4.67357 3.24719 4.4293 3.49166 4.12777 3.49174H2.91749C2.54254 3.49176 2.27372 3.78673 2.29357 4.11564L2.31911 4.47137C2.46452 6.2759 2.87446 8.43936 3.70515 10.175C4.59153 12.0271 5.88529 13.2664 7.7526 13.2665C8.05419 13.2665 8.2989 13.511 8.29891 13.8124C8.29891 14.1137 8.0542 14.3582 7.7526 14.3582C5.27711 14.3581 3.68944 12.672 2.7197 10.6458C1.74963 8.61891 1.32623 6.12583 1.20347 4.18418V4.18318C1.14182 3.18043 1.95964 2.40006 2.91749 2.40004H4.12777Z"
        fill={color}
      />
      <path
        d="M7.20117 15.0164V13.8071C7.20128 13.5059 7.44595 13.2618 7.74748 13.2618C8.049 13.2618 8.29367 13.5059 8.29378 13.8071V15.0164C8.29378 18.0503 10.7564 20.5109 13.7929 20.5109C16.8293 20.5109 19.292 18.0503 19.292 15.0164V12.6033C19.292 12.302 19.5367 12.0575 19.8383 12.0575C20.1398 12.0575 20.3841 12.302 20.3841 12.6033V15.0164C20.3841 18.653 17.4325 21.6026 13.7929 21.6026C10.1532 21.6026 7.20117 18.653 7.20117 15.0164Z"
        fill={color}
      />
    </svg>
  );
};

export default Stethoscope;
